import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Center, Table } from "@mantine/core"

import { Checkbox, Link } from "components";
import { AuthorityConstants, RouteConstants, ServiceConstants } from "constant";
import { UserService } from "services";
import { UserRecommendationResponse } from "types";
import { AppUtils, UserUtils } from "utils";

import { IRootState } from "config/redux";
import { TFunction } from "i18next";

const { ROLE_CR_R } = AuthorityConstants;
const { ROUTE_CLIENTS } = RouteConstants;
const { REQUEST_PENDING, REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID } = ServiceConstants;

interface UserRecommendationListItemProps {
  item: UserRecommendationResponse;
  t: TFunction;
}
const UserRecommendationListItem = ({ item, t }: UserRecommendationListItemProps) => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID + item.id]);
  const [inCrm, setInCrm] = useState<boolean>(item.crm);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID + item.id, setInCrm);
  }, [serviceObject]);

  const inCrmChange = useCallback(() => UserService.userRecommendationTransferToCrm(item.id), []);
  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <Table.Tr key={item.id}>
      <Table.Td>{item.fullName}</Table.Td>
      <Table.Td>{item.countryCode + ' ' + item.phoneNumber}</Table.Td>
      <Table.Td visibleFrom={'md'}>
        {UserUtils.hasAuthority(ROLE_CR_R) ?
          <Link to={`${ROUTE_CLIENTS}/${item.info.createdBy.id}`}>
            {item.info.createdBy.fullName}
          </Link>
          : item.info.createdBy.fullName}
      </Table.Td>
      <Table.Td>{t('format.date', { date: new Date(item.info.createdAt) })}</Table.Td>
      <Table.Td visibleFrom={'md'}>
        <Center>
          <Checkbox
            checked={inCrm}
            onChange={inCrmChange}
            loading={isLoading}
            readOnly={!UserUtils.hasAuthority(AuthorityConstants.ROLE_USR_REC_U)}
          />
        </Center>
      </Table.Td>
    </Table.Tr>
  )
}

export default UserRecommendationListItem;